import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_835gopvdlg: FaireBrandEntity = {
  token: "b_835gopvdlg",
  type: "brand",
  name: "Puebco",
  avatarUrl: "https://cdn.faire.com/fastly/f102403322778038ecb9f7bbdfb7b2adbb9d26000c0aba1a06b5e9f6461e2ece.png",
  bannerUrl: "https://cdn.faire.com/fastly/1911c6b4030156a0332347be0a5077e65e3af13b50378d82197fc9624e05b487.jpeg",
  logoUrl: "https://cdn.faire.com/fastly/f102403322778038ecb9f7bbdfb7b2adbb9d26000c0aba1a06b5e9f6461e2ece.png",
  heroImageUrl: "https://cdn.faire.com/fastly/1911c6b4030156a0332347be0a5077e65e3af13b50378d82197fc9624e05b487.jpeg",
  location: "Boardman, OH, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 64,
  isTopShop: true,
  isInsider: true,
  description: "PUEBCO was born in Japan 2007 with the simple notion of creating things instinctively, using found and recycled materials to curate renewed lifestyle items. PUEBCO believes that just as people are the sum of their lived experiences, the objects we share our homes with should carry that same sense of history and weight. By using recycled materials and hand made processes, PUEBCO imbues these objects with the feel of many lifetimes and a sense of history that makes each piece unique. With PUEBCO products, there are no imperfections but details meant by design.",
  meta: {
    source: "api",
    importedAt: "2026-10-14T17:08:02.706Z",
    importedBy: "entity-db-cli"
  }
};
